module.exports = __webpack_public_path__ + "officialStatic/img/logo9.0fe7cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo9.png
// module id = crVA
// module chunks = 0